import { ComboFormModel } from "../modelos/rota/comboFormModel";

export const COMBO_FORM_INITIAL_STATE: ComboFormModel = {
    nome: "",
    idOcorrencia: "",
    valor: 0,
  };
  